import { Component, OnDestroy, OnInit, SimpleChanges, Input, OnChanges, EventEmitter, Output } from '@angular/core';
import { IDtoCustomer } from 'app/shared/models/customer/dto-customer.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomerService } from '../../quote/customer.service';
import { ValidatorService } from 'app/shared/services/validator.service';
import { Observable, Subject } from 'rxjs';
import { FormGroup, Validators } from '@angular/forms';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { IDtoProject } from 'app/shared/models/customer/dto-project.model';
import { OrganizationService } from '../../organization/organization.service';
import { IDtoCompany } from 'app/shared/models/organization/dto-company.model';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: '[customer]',
    styleUrls: ['./customer.style.scss'],
    templateUrl: './customer.template.html'
})
export class CustomerComponent implements OnDestroy, OnInit {
    private validator = ValidatorService;
    private fsaFlags = [false];
    private flag = false;
    private errorMessages: any;
    private customer: IDtoCustomer;
    private staffType: string;
    private catalogCustomers: Observable<IDtoCatalog[]>;
    private catalogProjects: Observable<IDtoProject[]>;
    @Input() module: string;
    @Input() group: FormGroup;
    @Input() action: string;
    @Input() resetCustomerId: Subject<number> = new Subject<number>();
    @Output() selected = new EventEmitter<IDtoCustomer>();
    @Output() resetForm = new EventEmitter<boolean>();
    constructor(private spinner: NgxSpinnerService
        , private customerService: CustomerService
        , private configurationService: ConfigurationService
        , private organizationService: OrganizationService
        , private route: ActivatedRoute) {
        this.customer = {} as IDtoCustomer;
        if (this.configurationService.isReady) {
            this.catalogCustomers = this.customerService.getCatalogCustomers();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.catalogCustomers = this.customerService.getCatalogCustomers();
            });
        }
    }


    ngOnInit(): void {
        this.resetCustomerId.subscribe(res => {
            if (res) {
                var customer = {} as IDtoCatalog;
                customer.id = res;
                this.getCustomer(customer, false);
                if (this.action == 'update') {
                    this.group.controls['projectId'].disable();
                }
            }
        })
    }

    ngOnDestroy(): void {
    }
    private getCustomer(customer: IDtoCatalog, isChanged: boolean): void {
        
        if (customer === undefined) {
            this.selected.emit(undefined)
            this.customer = {} as IDtoCustomer;
            this.catalogProjects = Observable.of([] as IDtoProject[]);
        } else {
            this.spinner.show()
            this.customerService.getCustomerById(customer.id)
                .subscribe(
                    (x) => {
                        this.customer = x.data as IDtoCustomer;
                        this.selected.emit(this.customer)
                        if(isChanged) {
                            this.resetForm.emit(true);
                        }
                        if(this.customer.staffTypeName == 'Oficina' && this.module != 'BudgetCreation') {
                            this.group.get('projectId').setValidators([Validators.required]);
                            this.getProjects(this.customer.id);
                        } else {
                            this.group.get('projectId').setValidators(null);
                        }
                        this.group.get('projectId').updateValueAndValidity();
                        this.spinner.hide();
                    },
                    (errMessage) => this.errorMessages = errMessage.messages);
        }
    }
    private getProjects(id: number): void {
        this.spinner.show()
        this.customerService.getProyectsByCustomer(id)
            .subscribe(
                (x) => {
                    this.catalogProjects = Observable.of(x.data as IDtoProject[]);
                    let projectId =  this.group.controls['projectId'].value;
                    if (this.action == 'update') {
                        this.catalogProjects.subscribe(x => {
                            let project = x.filter(x=> x.id == projectId)[0];
                            //this.getPayCompany(project.payCompanyId);
                            this.customer.payCompany =  project.payCompany;
                            this.customer.payCompanyId = project.payCompanyId;
                            this.customer.riskPremiumValue = project.riskPremiumValue;
                            this.selected.emit(this.customer)
                        })
                    }
                    this.spinner.hide();
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private changeProject(project: IDtoProject): void {
        if (this.customer.payCompanyId != project.payCompanyId) {
            //this.getPayCompany(project.payCompanyId);
            this.customer.payCompany =  project.payCompany;
            this.customer.payCompanyId = project.payCompanyId;
            this.selected.emit(this.customer)
        }
        this.customer.riskPremiumValue = project.riskPremiumValue;
    }
    private getPayCompany(id: number): void {
        this.spinner.show()
        this.organizationService.getCompanyById(id)
            .subscribe(
                (x) => {
                    this.customer.payCompany =  x.data as IDtoCompany;
                    this.customer.payCompanyId = id;
                    this.selected.emit(this.customer)
                    this.spinner.hide();
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private viewCustomerDetail(): boolean {
        let isVisible = true;
        if (this.customer.staffTypeName == 'Oficina' && this.module != 'BudgetCreation') {
            if (this.group.get('projectId').value != null) {
                return true;
            } else {
                return false;
            }
        } else {
            if (this.group.value.customerId != null) {
                return true;
            } else {
                return false; 
            }
        }
    }
}
